import React from 'react'

const Empty = function(props){
    return ( <div></div>)
}

export default Empty